import { IAPIRoutes } from "../../../../config";

export const SummaryRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getSummaryAPI: IGetSummaryAPI = async (payload) =>
    GET(
      APIRoutes.apiGetSummary.replace(
        "{clinic_id}",
        payload.clinic_id?.toString()
      ),
      payload,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );

  const getDotPhrasesListAPI: IGetDotPhrasesListAPI = async (payload) =>
    GET(`${APIRoutes.apiGetDotPhrasesList}/${payload.of_type}`, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });

  return {
    getSummaryAPI,
    getDotPhrasesListAPI,
  };
};
